import { useInfiniteQuery } from 'react-query';
import { GPPendingActivityListRequest } from './pending-activities.types';
import pendingActivitiesServices from './pending-activities.services';

export const PENDING_ACTIVITY_LIST_KEY = 'pending-activity/list';

export function usePendingActivityList(params?: GPPendingActivityListRequest) {
  return useInfiniteQuery({
    queryKey: [PENDING_ACTIVITY_LIST_KEY, { ...params }],
    enabled: !!params?.companyIds?.length,
    queryFn: ({ pageParam }) =>
      pendingActivitiesServices.list({
        limit: 10,
        ...params,
        nextToken: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
  });
}
